import { useTranslation } from "react-i18next";

import StarsIcon from "./icons/starts.icon";

type Props = {
  setValue: any;
  watch: any;
  name: string;
};

function AiQC({ setValue, watch, name }: Props) {
  const { t } = useTranslation();
  const isChecked = watch(name);

  const handleChange = () => {
    setValue(name, !isChecked);
  };

  return (
    <label
      className={`tw-w-full tw-cursor-pointer tw-self-stretch tw-pl-[15px] tw-pr-5 tw-py-2.5 tw-bg-white tw-rounded-[99px] tw-shadow tw-border tw-border-solid ${
        isChecked
          ? "tw-border-solid tw-border-blue-800 tw-font-normal"
          : "tw-border-gray-300 tw-font-light"
      } tw-flex tw-items-center tw-gap-2 tw-mt-auto`}
    >
      <div className="tw-flex tw-items-center tw-flex-grow">
        <StarsIcon theme={isChecked ? "blue" : "white"} />
        <div
          className={`${
            isChecked ? "tw-text-blue-800" : "tw-text-gray-800"
          } text-sm font-['Lexend'] leading-tight tw-ml-2`}
        >
          <span className="tw-italic">{t("MacBotResponseForm/l-05")}</span>
        </div>
      </div>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        className="tw-h-4 tw-w-4 tw-rounded tw-border-gray-300 tw-text-blue-800 focus:tw-ring-blue-800"
      />
    </label>
  );
}

export default AiQC;
